import 'dayjs/locale/en'
import 'dayjs/locale/en-gb'
import 'dayjs/locale/nl'

// oxlint-disable-next-line no-restricted-imports
import { extend } from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import duration from 'dayjs/plugin/duration'
import isBetween from 'dayjs/plugin/isBetween'
import isLeapYear from 'dayjs/plugin/isLeapYear'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import minMax from 'dayjs/plugin/minMax'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'

// Initialize DayJs with all the plugins used by the system.
extend(localizedFormat)
extend(duration)
extend(isLeapYear)
extend(minMax)
extend(utc)
extend(customParseFormat)
extend(isBetween)
extend(relativeTime)
